define('models/pages/multi-account/summary',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var Table = Model.extend({
        urlPath: '/api/multi-account/summary',
        urlParams: function() {
            return this.get('params').urlParams();
        },
        defaults: {
            incomeSaldo: 0,
            outcomeSaldo: 0,
            debitTurnover: 0,
            creditTurnover: 0
        }
    });

    return Table;
});


